
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 1.186v4.951a.86.86 0 01-.857.857.86.86 0 01-.857-.857V1.186a.86.86 0 01.857-.858c.471 0 .857.378.857.858zM19.431.328a.86.86 0 00-.857.858v4.951a.86.86 0 00.857.858.86.86 0 00.858-.858V1.186a.86.86 0 00-.858-.858zm-3.72 0a.86.86 0 00-.857.858v4.951a.86.86 0 00.857.857.86.86 0 00.857-.857V1.186a.849.849 0 00-.857-.858zM12 .328a.86.86 0 00-.857.858v4.951a.86.86 0 00.857.858.86.86 0 00.857-.858V1.186A.86.86 0 0012 .328zm-3.711 0a.86.86 0 00-.857.858v4.951a.86.86 0 00.857.858.86.86 0 00.857-.858V1.186a.854.854 0 00-.857-.857zm-3.72 0a.86.86 0 00-.858.858v4.951a.86.86 0 00.857.857.86.86 0 00.858-.857V1.186a.854.854 0 00-.858-.858zm-3.712 0A.86.86 0 000 1.187v4.951a.86.86 0 00.857.858.86.86 0 00.857-.858V1.186A.854.854 0 00.857.329z","fill":"#fff"}})])
          )
        }
      }
    